import { Col } from "react-bootstrap"
import { ScreenSize, useScreenSize } from "@/ui/hooks/useScreenSize";
import { IContactUsData } from "@/domain/interfaces/IContactUs";
import Icon from "@/ui/assets/Icon";

/**
 * Componente para información de contacto 
 * @component
  */
const ContactUs = ({
    title,
    description,
    phoneNumber,
    email,
}: IContactUsData): JSX.Element => {
    /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido  */
    const { width, maxLargeWidth }: ScreenSize = useScreenSize();

    /** Variable que define si es entorno mobile o desktop */
    const isMobile: boolean = width < maxLargeWidth;

    return (
        <Col lg={9} className='d-flex flex-column'>
            <span className={`text-secondary-1 ${isMobile ? 'h2' : 'h1'} text-center`}>
                {title}
            </span>
            <span className={`text-justify px-3 text-secondary-2 ${isMobile ? 'p-regular pb-3' : 'p-large'}`}>
                {description}
            </span>
            <span className={`text-center ${isMobile ? 'pb-3' : 'pt-5'}`}>
                <Icon name='ico-whatsapp' classMain='pe-3'></Icon>
                <span className='text-secondary-1'>{phoneNumber}</span>
            </span>
            <span className={`text-center  ${isMobile ? 'mb-4' : 'pt-4'}`}>
                <Icon name='ico-email' classMain='pe-3'></Icon>
                <span className='text-secondary-1'>{email}</span>
            </span>
        </Col>
    )
}

export default ContactUs